module.exports = __webpack_public_path__ + "assets/img/collect-cards-detail.1e71f046.png";